export default __webpack_public_path__ + "static/media/godot.286b5fce.png";